<template>

    <Sankey />

</template>


<script>
import Sankey from '@/components/Sankey'


export default {
  name: 'MainComponent',
  components: {
    Sankey
  },
  methods:{
  }


}
</script>
<style scoped>
  .input-group__details:focus {
     border-bottom: 1px solid #f0f;
     box-shadow: 0 1px 0 0 #f0f;
   }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue